import { APP_COMMAND_KEY } from './types.js';
export function createCommandRegistry(onHandlerError) {
    const handlers = new Map();
    return {
        register(name, handler) {
            const wrapped = handler;
            handlers.set(name, wrapped);
            return () => {
                if (handlers.get(name) === wrapped)
                    handlers.delete(name);
            };
        },
        async dispatch(command) {
            const handler = handlers.get(command.name);
            if (!handler)
                return false;
            try {
                await handler(command.args);
                return true;
            }
            catch (error) {
                onHandlerError?.(command, error);
                return false;
            }
        },
        has(name) {
            return handlers.has(name);
        },
        list() {
            return Array.from(handlers.keys());
        },
    };
}
export function extractAppCommand(result) {
    if (!result || typeof result !== 'object' || Array.isArray(result)) {
        return { command: null, cleanResult: result };
    }
    const payload = result;
    if (!(APP_COMMAND_KEY in payload)) {
        return { command: null, cleanResult: result };
    }
    const rawCommand = payload[APP_COMMAND_KEY];
    if (!rawCommand
        || typeof rawCommand !== 'object'
        || Array.isArray(rawCommand)
        || typeof rawCommand.name !== 'string'
        || !rawCommand.name) {
        return { command: null, cleanResult: result };
    }
    const commandPayload = rawCommand;
    const command = commandPayload.args === undefined
        ? { name: commandPayload.name }
        : { name: commandPayload.name, args: commandPayload.args };
    const cleanResult = Object.fromEntries(Object.entries(payload).filter(([key]) => key !== APP_COMMAND_KEY));
    return { command, cleanResult };
}
//# sourceMappingURL=CommandRegistry.js.map